import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';
import { StorageKey, StorageType } from '../storage-key';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BlogapiService {
  headers: HttpHeaders;
  blogBaseUrl: string = environment.blogUrl;

  constructor(private http: HttpClient, private storage: StorageService) {
    this.headers = new HttpHeaders();
  }

  setHeader(headers?: any) {
    var headersArray = headers ? headers : {};
    if (Object.keys(headersArray).filter((x) => x == 'Content-Type').length <= 0) {
      headersArray['Content-Type'] = 'application/json';
      headersArray['X-Wp-Totalpages'];
      headersArray['Referrer-Policy'] = 'no-referrer';
      headersArray['Referer'] = 'http://stageblog.askiitians.com/';

    }
    if (
      this.storage.getItem(StorageKey.TOKEN, StorageType.LOCAL) != null &&
      this.storage.getItem(StorageKey.TOKEN, StorageType.LOCAL) != undefined
    ) {
      const token = this.storage.getItem(StorageKey.TOKEN, StorageType.LOCAL);
      if (Object.keys(headersArray).filter((x) => x == 'Authorization').length <= 0) {
        headersArray['Authorization'] = 'Bearer ' + token;
      }
    }
    this.headers = new HttpHeaders(headersArray);
  }

  public Get(url: string, params?: any, headers?: any, responseType?: any, addBaseUrl: boolean = true): Observable<any> {
    try {
      return this.http.get(addBaseUrl ? this.blogBaseUrl + url : url, { headers: headers, params, responseType: responseType ?? 'json', observe: 'response' });
    } catch (error) {
      throw error;
    }
  }
  public GetBlogDetails(url: string, params?: any, responseType?: any): Observable<any> {
    try {
      return this.http.get(this.blogBaseUrl + url, { headers: this.headers, params, responseType: responseType ?? 'json', observe: 'response' });
    } catch (error) {
      throw error;
    }
  }
}
